import css from 'styled-jsx/css';

export default css`
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .header-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 75%;
  }
  .header {
    font-size: 40px;
    font-family: "Eurostile-Bold";
    margin-top: 5%;
    margin-bottom: 1%;
  }
  .description {
    font-size: 16px;
    margin-bottom: 3%;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;
    display: inherit;
  }
  .btn {
    width: 181px;
    height: 42.28px;
    vertical-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    margin-right: 1%;
    font-family: DINPro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
  }
  .btn-container-mobile {
    display: none;
    align-items: center;
    justify-content: space-between;
    width: 45%;
    margin-top: 5%;
  }
  .btn-mobile {
    height: 57px;
    width: 57px;
    border-radius: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
  }
  .btn-mobile-label {
    font-size: 14px;
    font-weight: 600;
  }
  .btn-icon {
    width: 30px;
    height: 30px;
    margin-right: 1%;
  }
  .btn-icon-mobile {
    width: 40px;
    height: 40px;
  }
  .whatsapp {
    background-color: #0DC142;
  }
  .livechat {
    background-color: #950810;
  }
  .main-header {
    display: none;
    font-size: 48px;
    font-family: "big_noodle_titling";
    margin-top: 10%;
    margin-bottom: 1%;
  }
  @media (max-width: 600px) {
    .main-header {
      display: block;
    }
    .header-container {
      width: 100%;
    }
    .header {
      font-size: 32px;
      text-align: center;
    }
    .description {
      padding-right: 25px;
      padding-left: 25px;
      text-align: center;
    }
    .btn-container {
      display: none;
    }
    .btn-container-mobile {
      display: flex;
    }
  }
`;